import api from './api';

const expenseReimbursementService = {
  // Get all reimbursements
  getAllReimbursements: async (params = {}) => {
    try {
      const response = await api.get('/expense-reimbursement', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting reimbursements:', error);
      throw error;
    }
  },

  // Get a single reimbursement by ID
  getReimbursementById: async (id) => {
    try {
      const response = await api.get(`/expense-reimbursement/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting reimbursement:', error);
      throw error;
    }
  },

  // Get next reimbursement number
  getNextReimbursementNumber: async () => {
    try {
      const response = await api.get('/expense-reimbursement/code/next');
      return response.data;
    } catch (error) {
      console.error('Error getting next reimbursement number:', error);
      throw error;
    }
  },

  // Get approved claims ready for reimbursement
  getApprovedClaimsForReimbursement: async (params = {}) => {
    try {
      const response = await api.get('/expense-reimbursement/approved-claims', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting approved claims:', error);
      throw error;
    }
  },

  // Create a new reimbursement
  createReimbursement: async (data) => {
    try {
      const response = await api.post('/expense-reimbursement', data);
      return response.data;
    } catch (error) {
      console.error('Error creating reimbursement:', error);
      throw error;
    }
  },

  // Update a reimbursement
  updateReimbursement: async (id, data) => {
    try {
      const response = await api.put(`/expense-reimbursement/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating reimbursement:', error);
      throw error;
    }
  },

  // Process a reimbursement
  processReimbursement: async (id, data = {}) => {
    try {
      const response = await api.put(`/expense-reimbursement/${id}/process`, data);
      return response.data;
    } catch (error) {
      console.error('Error processing reimbursement:', error);
      throw error;
    }
  },

  // Mark reimbursement as paid
  markAsPaid: async (id, data) => {
    try {
      const response = await api.put(`/expense-reimbursement/${id}/mark-paid`, data);
      return response.data;
    } catch (error) {
      console.error('Error marking reimbursement as paid:', error);
      throw error;
    }
  },

  // Delete a reimbursement
  deleteReimbursement: async (id) => {
    try {
      const response = await api.delete(`/expense-reimbursement/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting reimbursement:', error);
      throw error;
    }
  },

  // Get reimbursement statistics
  getReimbursementStats: async () => {
    try {
      const response = await api.get('/expense-reimbursement/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting reimbursement stats:', error);
      throw error;
    }
  }
};

export default expenseReimbursementService;

